import { isBaseUrlString as m, isUrlString as v, toBaseUrlStringOrUndefined as C } from "@made-people/types-url-string";
import S from "axios";
import { getGearsServiceUrl as b, getGearsConfigurationVariable as w } from "@made-people/gears-configuration";
class x {
  constructor(t) {
    if (this.options = t, !m(t.baseUrl))
      throw new Error(`${t.baseUrl} isn't a valid base URL`);
  }
  getXHeaders(t) {
    const e = {};
    for (const a of t.keys())
      if (/^x-forwarded-/i.test(a)) {
        const o = t.get(a);
        o && (e[a] = o);
      }
    return e;
  }
  /**
   * This method returns Response or undefined so the frontend
   * is forced to handle the absence of a response instead of
   * crashing due to a thrown error from a failing API request
   */
  async request(t, e, a = "get", o) {
    const r = [this.options.baseUrl, t].join("/");
    if (!v(r)) {
      console.error(`${r} isn't a valid URL string`);
      return;
    }
    const d = {};
    this.options.tenantId && (d["x-tenant-id"] = this.options.tenantId);
    const f = e.get("host");
    return f && (d["gears-host"] = f, e.get("x-forwarded-host") || e.set("x-forwarded-host", f)), [
      "cf-ipcountry",
      "cf-connecting-ip",
      "fastly-geoip-countrycode",
      "x-campaign-site-key"
    ].forEach((n) => {
      const c = e.get(n);
      c && (d[n] = c);
    }), S.request({
      url: r,
      method: a,
      data: o,
      headers: {
        ...d,
        ...this.getXHeaders(e)
      },
      validateStatus: function(n) {
        return n < 500;
      }
    }).then((n) => n.data).catch((n) => {
      var c, l, g, h, y, p;
      console.error({
        message: `Page lookup of ${r} failed`,
        request: {
          url: (c = n == null ? void 0 : n.config) == null ? void 0 : c.url,
          headers: (l = n == null ? void 0 : n.config) == null ? void 0 : l.headers,
          data: (g = n == null ? void 0 : n.config) == null ? void 0 : g.data
        },
        response: {
          status: (h = n == null ? void 0 : n.response) == null ? void 0 : h.status,
          headers: (y = n == null ? void 0 : n.response) == null ? void 0 : y.headers,
          data: (p = n == null ? void 0 : n.response) == null ? void 0 : p.data
        },
        error: {
          message: n == null ? void 0 : n.message,
          code: n == null ? void 0 : n.code,
          type: typeof n
        }
      });
    });
  }
  async initializeSelection(t, e) {
    const a = {
      ...t
    };
    a.campaignSite && delete a.campaignSite;
    const o = a;
    return this.request(
      `v1/centra/selection/${e ?? ""}?${new URLSearchParams(
        o
      )}`,
      new Headers(),
      "GET"
    );
  }
  async fetchFrontendProducts(t) {
    return this.request(
      "v1/centra/products-search",
      new Headers(),
      "POST",
      t
    );
  }
  async findPage(t) {
    return this.request(
      ["v1/page", t.url.pathname, t.url.search].join(""),
      t.headers
    );
  }
  async findRobotsTxt(t) {
    return this.request(
      ["v1/google-sitemap/robots-txt"].join(""),
      t.headers
    );
  }
  async findSitemapIndex(t) {
    return this.request(
      ["v1/google-sitemap/index"].join(""),
      t.headers
    );
  }
  async findSitemap(t) {
    return this.request(
      [`v1/google-sitemap/${t.type}/${t.slug}`].join(""),
      t.headers
    );
  }
  async findSiteContent(t, e) {
    return this.request(
      `v1/site/settings-and-content/${t}`,
      e
    );
  }
  async findFrontendContextByCountryAndLanguageCode(t, e) {
    return this.request(
      `v1/site/frontend-context?countryCode=${t}&languageCode=${e}`,
      new Headers()
    );
  }
  async findAlternateLinkForSlug(t) {
    return this.request(
      `v1/page/find-alternate-link/${t.fullSlug}`,
      new Headers(),
      "POST",
      {
        target: t.targetFrontendContext
      }
    );
  }
  async fetchEcomIdToken(t) {
    const e = await this.request(
      "v1/ecomid/sessions",
      new Headers(),
      "POST",
      { ref_id: t }
    );
    return e == null ? void 0 : e.token;
  }
  async resolveStoryblokStory(t) {
    return this.request(
      `v1/page/storyblok-preview/resolve-story?${Object.entries(
        t.frontendContext
      ).map(([e, a]) => `${e}=${a}`).join("&")}`,
      new Headers(),
      "POST",
      t.story
    ).catch((e) => {
      console.log(e);
    });
  }
  async getUserMeta() {
    return this.request("v1/user-meta", new Headers());
  }
  async fetchTrustpilotProductReviews(t) {
    return this.request(
      "v1/trustpilot/product-reviews",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchTrustpilotStoreReviews(t) {
    return this.request(
      "v1/trustpilot/store-reviews",
      new Headers(),
      "POST",
      t
    );
  }
  async fetchTrustpilotStoreSummary() {
    return this.request(
      "v1/trustpilot/store-summary",
      new Headers()
    );
  }
  async fetchTrustpilotProductSummary(t) {
    return this.request(
      `v1/trustpilot/product-summary?productSku=${encodeURIComponent(t.productSku)}`,
      new Headers()
    );
  }
}
let u;
function i() {
  const s = C(b("bff")), t = w("tenantId");
  if (typeof s > "u")
    throw new Error(
      `"${s}" isn't a valid base URL. Please make sure your environment variables are set correctly.`
    );
  return u || (u = new x({
    baseUrl: s,
    tenantId: t
  })), u;
}
const $ = async (s, t) => {
  const e = i();
  return s.pathname = s.pathname.replace(/^\/?/, "/"), e.findPage({
    url: s,
    headers: t
  }).catch((a) => {
  });
}, k = async (s) => i().findRobotsTxt({
  headers: s
}).catch((e) => {
}), H = async (s, t) => i().findSiteContent(s, t), I = async (s, t) => {
  const e = i(), [, , a, o] = s.pathname.split("/");
  if (!a || !o) {
    console.warn("Invalid sitemap url", s);
    return;
  }
  return e.findSitemap({
    type: a,
    slug: o,
    headers: t
  }).catch((r) => {
  });
}, L = async (s) => i().findSitemapIndex({
  headers: s
}).catch((e) => {
}), R = async () => i().getUserMeta().catch((t) => {
}), F = async (s) => {
  const t = i(), { fullSlug: e, targetFrontendContext: a } = s;
  return t.findAlternateLinkForSlug({
    fullSlug: e,
    targetFrontendContext: a
  });
}, O = async (s, t) => i().findFrontendContextByCountryAndLanguageCode(
  s,
  t
);
export {
  x as BffClient,
  $ as fetchPage,
  k as fetchRobotsTxt,
  H as fetchSettingsAndContent,
  I as fetchSitemap,
  L as fetchSitemapIndex,
  R as fetchUserMeta,
  F as findAlternateLinkForSlug,
  O as findFrontendContextByCountryAndLanguageCode,
  i as getBffClient
};
//# sourceMappingURL=lib.es.js.map
